module.exports = __webpack_public_path__ + "img/05.d9684ee3.png";